module.exports = __webpack_public_path__ + "media/images/top-parts-07-89862b8464a1001f0ab90ba1aac7224c.jpg";